<template>

  <div class="outer-black">
    <div class="usecase-layout">
      <!-- Header-Bereich -->
      <div class="header">
        <p class="welcome-text">Willkommen bei</p>
        <img class="logo" src="@/assets/placeholder6-opti.png" alt="Logo"/>
      </div>

      <!-- Mittelbereich mit Frage -->
      <main class="main">
        <h1 class="question">Wie möchtest du deine Bestellung?</h1>
      </main>

      <!-- Fußbereich mit Buttons -->
      <div class="footer">
        <div class="button-container">
          <!-- Zum Hier essen -->
          <button v-if="availableKioskOrderModes.includes('inhouse')"
            class="order-button px-4" @click="selectOption('inhouse')">
            <svg
              class="icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              aria-label="Zum Hier essen"
            >
              <title>Zum Hier essen</title>
              <!-- Teller außen -->
              <circle cx="32" cy="32" r="22" fill="none" stroke="#222" stroke-width="3"/>
              <!-- Teller innen -->
              <circle cx="32" cy="32" r="12" fill="none" stroke="#222" stroke-width="2"/>
            </svg>
            <span>Zum Hier essen</span>
          </button>

          <!-- Zum Mitnehmen -->
          <button v-if="availableKioskOrderModes.includes('takeAway')"
            class="order-button px-4"
            @click="selectOption('takeAway')"
            aria-label="Zum Mitnehmen"
          >
            <svg
              class="icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              role="img"
              aria-hidden="false"
            >
              <title>Zum Mitnehmen</title>

              <!-- Tüte Körper -->
              <path
                d="M18 22
                 h28
                 l-4 32
                 h-20
                 l-4 -32
                 z"
                fill="none"
                stroke="#222"
                stroke-width="3"
                stroke-linejoin="round"
              />

              <!-- Faltkante / Bodenlinie -->
              <line x1="22" y1="40" x2="42" y2="40" stroke="#222" stroke-width="1.5" opacity="0.9"/>

              <!-- Henkel: zwei geschwungene Linien, mittig oben -->
              <path d="M26 22
                     C26 14, 38 14, 38 22"
                    fill="none"
                    stroke="#222"
                    stroke-width="3"
                    stroke-linecap="round"/>

              <!-- optionales kleines Logo-Fenster / Design auf Tüte (als visueller Akzent) -->
              <rect x="28" y="28" width="8" height="6" rx="1" fill="none" stroke="#222" stroke-width="1.2" opacity="0.9"/>
            </svg>

            <span>Zum Mitnehmen</span>
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import store from "../store/store";
import {setGlobalKeyValue} from "../util/globalState";

export default {
  name: "WelcomeScreen",
  computed: {
    availableKioskOrderModes() {
      let modes = [];

      if (store.getters.enableKioskInhouseOhnePay) {
        modes.push('KioskInhouseOhnePay');
      }
      if (store.getters.enableKioskInhouseMitPay) {
        modes.push('KioskInhouseMitPay');
      }
      if (store.getters.enableKioskTakeAwayOhnePay) {
        modes.push('KioskTakeAwayOhnePay');
      }
      if (store.getters.enableKioskTakeAwayMitPay) {
        modes.push('KioskTakeAwayMitPay');
      }

      if (store.getters.enableKioskInhouseOhnePay || store.getters.enableKioskInhouseMitPay) {
        modes.push('inhouse');
      }
      if (store.getters.enableKioskTakeAwayOhnePay || store.getters.enableKioskTakeAwayMitPay) {
        modes.push('takeAway');
      }
      return modes;
    },
  },
  methods: {
    selectOption(option) {
      // inhouse
      // takeAway
      store.commit('setSelectedOrderModeByUser', '' + option);
      setGlobalKeyValue('userSwitchedOrderMode', true);

      store.commit('setShowKioskSplashOnHome', false);
      this.$router.replace({name: 'Sortiment'});
    },
  },
};
</script>

<style scoped lang="scss">
@import '../styles/base';

.outer-black {
  //background-color: black;
  //padding: 40px;
}

.usecase-layout {
  height: 100vh;
  width: 100vw;
  //height: calc(100vh - 80px);
  //width: calc(100vw - 80px);
  overflow: hidden;
  display: grid;

  //border-radius: 30px;

  /* Dynamische Höhenverhältnisse: Header : Main : Footer = 2 : 2 : 3 */
  grid-template-rows: 4fr 4fr 6fr;

  text-align: center;
  //background-color: #f8f8f8;

  ///* Farbverlauf: warm, modern */
  ///* Ableitung von $color-primary */
  //background: linear-gradient(
  //    135deg,
  //    lighten($color-secondary, 15%) 0%, // hellere Variante
  //    $color-secondary 50%, // Originalfarbe
  //    darken($color-secondary, 10%) 100% // dunklere Variante
  //);
}

/* --- HEADER --- */
.header {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.welcome-text {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  @include text-contrast($color-secondary);
}

.logo {
  height: 250px;
  margin-top: 20px;
  object-fit: contain;
}

/* --- MAIN --- */
.main {
  display: flex;
  justify-content: center;
  align-items: center;
}

.question {
  font-size: 2.3rem;
  margin: 0;
  @include text-contrast($color-secondary);
}

/* --- FOOTER --- */
.footer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 3rem;
  flex-wrap: wrap;
  margin-top: 2rem;
}

.order-button {
  //background-color: #ffcc00;
  background-color: $color-primary;
  @include button-contrast($color-primary);
  border: 2px solid black;
  @include border-contrast($color-primary);
  border-radius: 25px;
  width: 280px;
  height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}


.order-button:hover,
.order-button:focus {
  transform: scale(1.05);
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.25);
  outline: none;
}

/* --- SVG-Icons --- */
.icon {
  width: 88px;
  height: 88px;
  margin-bottom: 1rem;
  stroke: #222;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Kleinere Anpassungen für Touch-Usability */
.order-button span {
  margin-top: 4px;
}

/* Optional: responsive Anpassung für kleinere Displays */
@media (max-width: 760px) {
  .logo {
    height: 160px;
  }

  .order-button {
    width: 210px;
    height: 210px;
  }

  .icon {
    width: 64px;
    height: 64px;
  }

  .question {
    font-size: 1.6rem;
    padding: 0 1rem;
  }
}
</style>
